import React from 'react';

function BetaBadge() {
    return <span style={{ fontSize: 12, fontWeight: 800, background: '#ffe3a0', color: '#4a2f00', borderRadius: 3, padding: '1px 4px', marginLeft: 5, verticalAlign: 'middle', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>BETA</span>;
}

function WorkspaceSidebar({
    activeSection,
    setActiveSection,
    activeMarketplace,
    setActiveMarketplace,
    moduleFlags = {},
    userPlanFeatures = null,
    isBalanceRestricted = false,
    onOpenBilling
}) {
    const isVisible = (key) => (moduleFlags?.[key] || 'enabled') !== 'disabled';
    const isBeta = (key) => (moduleFlags?.[key]) === 'beta';

    // Пока фичи не загружены (null) — показываем всё (fail-open при загрузке).
    // После загрузки — скрываем то, чего нет в тарифе.
    const can = (key) => {
        if (userPlanFeatures === null) return true;
        const val = userPlanFeatures[key];
        if (val === undefined) return true;
        if (typeof val === 'boolean') return val;
        if (typeof val === 'number') return val !== 0;
        return Boolean(val);
    };

    const canUseMainModules = !isBalanceRestricted;

    return (
        <aside className="sidebar">
            <div className="sidebar__nav sidebar__group">
                {canUseMainModules && isVisible('ai_agent') && can('ai_agent') && (
                    <button
                        type="button"
                        className={activeSection === 'chat' ? 'active' : ''}
                        onClick={() => setActiveSection('chat')}
                    >
                        AI Агент{isBeta('ai_agent') && <BetaBadge />}
                    </button>
                )}
                {canUseMainModules && isVisible('projects') && (
                    <button
                        type="button"
                        className={activeSection === 'projects' ? 'active' : ''}
                        onClick={() => setActiveSection('projects')}
                    >
                        Проекты{isBeta('projects') && <BetaBadge />}
                    </button>
                )}
            </div>
            <div className="sidebar__marketplaces sidebar__group">
                {canUseMainModules && isVisible('ozon') && can('marketplace_access') && (
                    <button
                        type="button"
                        className={`marketplace-btn marketplace-btn--ozon ${activeMarketplace === 'ozon' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveMarketplace('ozon');
                            setActiveSection('marketplace');
                        }}
                    >
                        OZON{isBeta('ozon') && <BetaBadge />}
                    </button>
                )}
                {canUseMainModules && isVisible('wildberries') && can('wb_statistics') && (
                    <button
                        type="button"
                        className={`marketplace-btn marketplace-btn--wb ${activeMarketplace === 'wildberries' ? 'active' : ''}`}
                        onClick={() => {
                            setActiveMarketplace('wildberries');
                            setActiveSection('marketplace');
                        }}
                    >
                        Wildberries{isBeta('wildberries') && <BetaBadge />}
                    </button>
                )}
            </div>
            <div className="sidebar__divider" />
            <div className="sidebar__nav sidebar__group">
                {canUseMainModules && isVisible('crm') && can('crm') && (
                    <button
                        type="button"
                        className={activeSection === 'crm' ? 'active' : ''}
                        onClick={() => setActiveSection('crm')}
                    >
                        CRM{isBeta('crm') && <BetaBadge />}
                    </button>
                )}
                {canUseMainModules && isVisible('tasks') && can('tasks') && (
                    <button
                        type="button"
                        className={activeSection === 'tasks' ? 'active' : ''}
                        onClick={() => setActiveSection('tasks')}
                    >
                        Задачи{isBeta('tasks') && <BetaBadge />}
                    </button>
                )}
            </div>
            <div className="sidebar__divider" />
            <div className="sidebar__nav sidebar__nav--secondary">
                <button
                    type="button"
                    className={activeSection === 'help' ? 'active' : ''}
                    onClick={() => setActiveSection('help')}
                >
                    Справка
                </button>
                {isVisible('settings') && (
                    <button
                        type="button"
                        className={activeSection === 'settings' ? 'active' : ''}
                        onClick={() => setActiveSection('settings')}
                    >
                        Настройки
                    </button>
                )}
                {isBalanceRestricted && (
                    <button
                        type="button"
                        onClick={onOpenBilling}
                    >
                        Пополнить баланс
                    </button>
                )}
            </div>
        </aside>
    );
}

export default WorkspaceSidebar;
